module.exports = __webpack_public_path__ + "static/img/img1.fbbb7f0b.png";